export default __webpack_public_path__ + "static/media/logoGazin_alpha.8db2ba73.png";